import moment from "@/utils/moment";

const STATUSES_TO_CANCEL = [
  "scheduled",
  "requested_on_gateway",
  "created_on_gateway",
  "payment_requested",
  "waiting_payment",
  "paid",
  "rebooking",
  "not_paid"
];

const STATUSES_TO_RESCHEDULE = ["paid", "service_not_provided"];

const STATUSES_TO_REQUEST_INVOICE = [
  "paid",
  "provisioning",
  "complete",
  "service_not_provided"
];

const STATUSES_TO_CHECKOUT = [
  "created_on_gateway",
  "payment_requested",
  "waiting_payment"
];

const STATUSES_TO_SET_SERVICE_NOT_PROVIDED = [
  "paid",
  "provisioning",
  "complete"
];

const STATUSES_TO_RESTORE_TO_PAID = "service_not_provided";

const STATUSES = {
  created: {
    order: 1,
    name: "criado",
    icon: "done",
    color: "blue",
    description: "O pedido foi criado."
  },
  scheduled: {
    order: 2,
    name: "agendado",
    icon: "calendar_today",
    color: "blue",
    description: "O pedido foi agendado."
  },
  requested_on_gateway: {
    order: 3,
    name: "criando no wirecard",
    icon: "cloud_queue",
    color: "warning",
    description: "O pedido está sendo criado no wirecard."
  },
  failed_to_create_on_gateway: {
    order: 3.1,
    name: "erro ao criar no wirecard",
    icon: "cloud_queue",
    color: "error",
    description: "Aconteceu um erro ao criar o pedido no wirecard."
  },
  created_on_gateway: {
    order: 4,
    name: "criado no wirecard",
    icon: "cloud_done",
    color: "success",
    description: "O pedido foi criado no wirecard."
  },
  failed_to_request_payment: {
    order: 4.1,
    name: "erro ao criar o pagamento no wirecard",
    icon: "payment",
    color: "error",
    description: "Aconteceu um erro ao criar o pagamento do pedido no wirecard."
  },
  payment_requested: {
    order: 5,
    name: "pagamento requisitado",
    icon: "payment",
    color: "warning",
    description:
      "O método de pagamento foi informado, mas ainda não foi confirmado."
  },
  waiting_payment: {
    order: 6,
    name: "aguardando pagamento",
    icon: "payment",
    color: "warning",
    description: "O pagamento do pedido ainda não foi confirmado."
  },
  paid: {
    order: 7,
    name: "pago",
    icon: "payment",
    color: "success",
    description: "O pagamento foi confirmado."
  },
  not_paid: {
    order: 8,
    name: "não pago",
    icon: "payment",
    color: "error",
    description: "O pedido não foi pago."
  },
  rebooking: {
    order: 8.1,
    name: "remarcando",
    icon: "calendar_today",
    color: "warning",
    description: "O pedido está em processo de remarcação."
  },
  rescheduling: {
    order: 8.2,
    name: "reagendado",
    icon: "calendar_today",
    color: "warning",
    description: "O pedido está em processo de reagendamento."
  },
  provisioning: {
    order: 9,
    name: "pedido em andamento",
    icon: "cached",
    color: "blue",
    description: "O profissional está realizando a limpeza."
  },
  service_not_provided: {
    order: 10,
    name: "serviço não realizado",
    icon: "error_outline",
    color: "error",
    description: "O serviço não foi realizado."
  },
  complete: {
    order: 11,
    name: "completo",
    icon: "done_all",
    color: "success",
    description: "O pedido está completo."
  },
  waiting_refund: {
    order: 12,
    name: "aguardando reembolso",
    icon: "money_off",
    color: "warning",
    description: "O reembolso foi solicitado, mas ainda não foi realizado."
  },
  cancelled: {
    order: 13,
    name: "cancelado",
    icon: "block",
    color: "error",
    description: "O pedido foi cancelado."
  }
};

export default {
  methods: {
    canCancel(status) {
      return STATUSES_TO_CANCEL.includes(status);
    },

    canReschedule(status) {
      return STATUSES_TO_RESCHEDULE.includes(status);
    },

    canRequestInvoice(status) {
      return STATUSES_TO_REQUEST_INVOICE.includes(status);
    },

    canSetServiceNotProvided(status) {
      return STATUSES_TO_SET_SERVICE_NOT_PROVIDED.includes(status);
    },

    canRestoreToPaid(status) {
      return STATUSES_TO_RESTORE_TO_PAID === status;
    },

    canGoToCheckout(order) {
      //Checking if have time to pay
      if (!this.haveTimeToPay(order.created_at)) return;

      //Checking if order have valid payment
      if (this.haveValidPayment(order.payments)) return;

      //Checking if order status is valid to create payment
      return STATUSES_TO_CHECKOUT.includes(order.status);
    },

    haveTimeToPay(created_at) {
      let diffTime =
        moment(created_at)
          .add(20, "minutes")
          .unix() - moment().unix();

      return diffTime <= 0;
    },

    haveValidPayment(payments) {
      if (payments.length) {
        let validPayment = payments.find(
          payment =>
            (payment.status === "waiting" &&
              payment.funding_instrument.type === "boletos") ||
            payment.status === "authorized"
        );

        return validPayment;
      }
    },

    getStatus(status) {
      return STATUSES[status];
    }
  },

  filters: {
    durationInHous(durationInMinutes) {
      return `${durationInMinutes / 60} horas`;
    },

    getStatusName(status) {
      return STATUSES[status].name;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/orderMixin.js